import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";

export default function MineActiveContestTimesheet() {
  const [show, setshow] = useState(false);
  const path = "Assets/scss/dashboard.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  return (
    <div className ="timesheet">
      <h6>Timesheet</h6>
      <div className ="row active-row">
        <div className ="col-md-4 signup-back">
          <div className ="signup-sec">
            <p>Total Logged hour</p>
            <h4>129 hrs</h4>
          </div>
        </div>
        <div className ="col-md-4 signup-back">
          <div className ="signup-sec">
            <p>Logged this week</p>
            <h4>45 hrs</h4>
          </div>
        </div>
        <div className ="col-md-4 signup-back">
          <div className ="signup-sec">
            <p>Total Cost this week : S18/hr</p>
            <h4>$810</h4>
          </div>
        </div>
      </div>
      <div className ="tab-sec">
        <div className ="timesheet-tab">
          <ul className ="nav nav-tabs">
            <li className ="nav-item">
              <a  data-toggle="tab" className ="nav-link active">
                Pending Sheets
              </a>
            </li>
            <li className ="nav-item">
              <a  data-toggle="tab" className ="nav-link ">
                Archived
              </a>
            </li>
          </ul>
          <button className =" buttons background-button">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/approve.svg`}
              alt=""
            />
            Approve all
          </button>
        </div>
        <div className ="tab-content">
          <div className ="tab-pane active" id="pending">
            <div className ="week-section">
              <div className ="tabcont-heading">
                <h5>Last week</h5>
                <h5>Weekly Total : 06:45:00</h5>
              </div>
              <div className ="week-collpase">
                <h6 className ="" onClick={() => setshow(!show)}>
                  Today, Mar 29 <span>Total : 02:15:00</span>
                </h6>
                <div className ={`mockup-row ${show ? "show" : ""}`}>
                  <div className ="mockup">
                    <div className ="col-md-12">
                      <div className ="row align-items-center">
                        <div className ="col-md-5">
                          <p>
                            worked on mockup creation and researched on some
                            royalty free assets
                          </p>
                        </div>
                        <div className ="col-md-3 mockup-center">
                          <p>12:30 AM</p>
                          <p>2:45 PM</p>
                        </div>
                        <div className ="col-md-4 mockup-right">
                          <h5>02:15:00</h5>
                          <p className ="pending">Pending</p>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circleclose-icon.svg`}
                              alt=""
                            />
                          </a>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circle-tick.svg`}
                              alt=""
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className ="mockup">
                    <div className ="col-md-12">
                      <div className ="row align-items-center">
                        <div className ="col-md-5">
                          <p>
                            worked on mockup creation and researched on some
                            royalty free assets
                          </p>
                        </div>
                        <div className ="col-md-3 mockup-center">
                          <p>12:30 AM</p>
                          <p>2:45 PM</p>
                        </div>
                        <div className ="col-md-4 mockup-right">
                          <h5>02:15:00</h5>
                          <p className ="pending">Pending</p>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circleclose-icon.svg`}
                              alt=""
                            />
                          </a>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circle-tick.svg`}
                              alt=""
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className ="week-section">
              <div className ="tabcont-heading">
                <h5>Mar 19 - Mar 25, 2024</h5>
                <h5>Weekly Total : 06:45:00</h5>
              </div>
              <div className ="week-collpase">
                <h6 className ="" onClick={() => setshow(!show)}>
                  Mar 21 <span>Total : 02:15:00</span>
                </h6>
                <div className ={`mockup-row ${show ? "show" : ""}`}>
                  <div className ="mockup">
                    <div className ="col-md-12">
                      <div className ="row align-items-center">
                        <div className ="col-md-5">
                          <p>
                            worked on mockup creation and researched on some
                            royalty free assets
                          </p>
                        </div>
                        <div className ="col-md-3 mockup-center">
                          <p>12:30 AM</p>
                          <p>2:45 PM</p>
                        </div>
                        <div className ="col-md-4 mockup-right">
                          <h5>02:15:00</h5>
                          <p className ="pending">Pending</p>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circleclose-icon.svg`}
                              alt=""
                            />
                          </a>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circle-tick.svg`}
                              alt=""
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className ="week-collpase">
                <h6 className ="" onClick={() => setshow(!show)}>
                  Mar 19 <span>Total : 02:15:00</span>
                </h6>
                <div className ={`mockup-row ${show ? "show" : ""}`}>
                  <div className ="mockup ">
                    <div className ="col-md-12">
                      <div className ="row align-items-center">
                        <div className ="col-md-5">
                          <p>
                            worked on mockup creation and researched on some
                            royalty free assets
                          </p>
                        </div>
                        <div className ="col-md-3 mockup-center">
                          <p>12:30 AM</p>
                          <p>2:45 PM</p>
                        </div>
                        <div className ="col-md-4 mockup-right">
                          <h5>02:15:00</h5>
                          <p className ="pending">Pending</p>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circleclose-icon.svg`}
                              alt=""
                            />
                          </a>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circle-tick.svg`}
                              alt=""
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className ="mockup">
                    <div className ="col-md-12">
                      <div className ="row align-items-center">
                        <div className ="col-md-5">
                          <p>
                            worked on mockup creation and researched on some
                            royalty free assets
                          </p>
                        </div>
                        <div className ="col-md-3 mockup-center">
                          <p>12:30 AM</p>
                          <p>2:45 PM</p>
                        </div>
                        <div className ="col-md-4 mockup-right">
                          <h5>02:15:00</h5>
                          <p className ="pending">Pending</p>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circleclose-icon.svg`}
                              alt=""
                            />
                          </a>
                          <a>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/circle-tick.svg`}
                              alt=""
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
